import { ApiMutualFundAssetRead, ApiSegregatedPortfolioAssetRead } from 'api/rtk-api'
import { useState } from 'react'

import { Tabs } from '../..'
import { Details } from './details'
import { Strategies } from './strategies'

type AssetInformationProps = {
  asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
}

type TabName = 'details' | 'strategies'

export function AssetInformation({ asset }: AssetInformationProps) {
  const [selectedTab, setSelectedTab] = useState<TabName>('details')
  return (
    <>
      <Tabs.List ruleClassName="mb-4" spacing="md">
        <Tabs.Tab
          isSelected={selectedTab === 'details'}
          value="details"
          onClick={() => setSelectedTab('details')}
        >
          Details
        </Tabs.Tab>
        <Tabs.Tab
          isSelected={selectedTab === 'strategies'}
          value="strategies"
          onClick={() => setSelectedTab('strategies')}
        >
          Strategy permissions
        </Tabs.Tab>
      </Tabs.List>

      {selectedTab === 'details' && (
        <Tabs.Panel value="details">
          <Details asset={asset} />
        </Tabs.Panel>
      )}

      {selectedTab === 'strategies' && (
        <Tabs.Panel value="strategies">
          <Strategies asset={asset} />
        </Tabs.Panel>
      )}
    </>
  )
}
